import {FormGroup, AbstractControl} from '@angular/forms';
import {EloquentValidation} from '../interfaces/interfaces';
export abstract class BaseModel implements EloquentValidation {

    public id: number = null;
    public validation: any;

    protected isValid = true;

    form_group: FormGroup;

    public getApiPrefix() {

    }

    form(key: string): AbstractControl {
        return this.form_group.get(key);
    }

    revalidate() {
        Object.keys(this.form_group.controls).forEach(key => {
            this.form_group.get(key).markAsTouched();
            this.form_group.get(key).updateValueAndValidity();
        });
    }


    public toJSON() {

        const jsonObject = {};

        Object.keys(this).forEach(key => {
            if (key !== 'form_group') {
                jsonObject[key] = this[key];
            }
        });

        return jsonObject;
    }

}




// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/shared/eloquent/models/base.model.ts